import type { ReactNode } from 'react';
import { ImagePreviewGrid } from './ImagePreviewGrid';

// Both task types use the same layout and image states. Only URL acquisition differs.
export function TaskEvidenceGallery({ children }: { children: ReactNode }) {
  return <div className="grid w-[220px] max-w-full grid-cols-5 gap-1">{children}</div>;
}

export function TaskEvidenceThumbnail({
  src, fullSrc, label, error = false, unavailable = false, onRetry,
}: {
  src?: string | null;
  fullSrc?: string | null;
  label: string;
  error?: boolean;
  unavailable?: boolean;
  onRetry?: () => void;
}) {
  if (!src) {
    return (
      <div className="flex h-12 w-full items-center justify-center rounded-md border border-gray-200 bg-gray-50 text-center text-[10px] text-gray-400">
        {unavailable ? '截图不可用' : error ? (
          <button type="button" onClick={onRetry} className="h-full w-full px-1 text-primary">加载失败，重试</button>
        ) : '截图加载中'}
      </div>
    );
  }
  return (
    <ImagePreviewGrid
      images={[{ src, fullSrc: fullSrc ?? undefined }]}
      onRetryImage={onRetry}
      altPrefix={label}
      gridClassName="grid w-full"
      thumbClassName="h-12"
    />
  );
}
